import { isStepParameterName } from "./get-step-parameter-name";

/**
 * The page's query parameters without the step parameters lead flows write,
 * sorted so their order does not start a new session.
 */
function getSessionParameters(
  searchParams: Pick<URLSearchParams, "entries">,
): URLSearchParams {
  const sessionParameters = new URLSearchParams();

  for (const [name, value] of searchParams.entries()) {
    if (!isStepParameterName(name)) {
      sessionParameters.append(name, value);
    }
  }

  sessionParameters.sort();
  return sessionParameters;
}

/**
 * Identifies one lead flow answer session: the page URL without the step
 * parameters lead flows write.
 */
function getSessionKey(
  pathname: string,
  searchParams: Pick<URLSearchParams, "entries">,
): string {
  const queryString = getSessionParameters(searchParams).toString();

  return queryString ? `${pathname}?${queryString}` : pathname;
}

export { getSessionKey, getSessionParameters };
